require('../module/share.js');
require('../module/image.js');

window.news = {

    page: 1,
    data: false,
    last_page: false,

    init: function () {
        $(document).on('click', '[news-prev]', function () {
            if (news.page > 1) {
                news.load(news.page - 1);
            }
        });

        $(document).on('click', '[news-next]', function () {
            if (news.page < news.last_page || !news.last_page) {
                news.load(news.page + 1);
            }
        });
    },

    // 2020-09-12T20:42:42.000000Z в 02 сентября 2020
    date: function (datetime) {
        return moment(datetime).format('DD MMMM YYYY');
    },

    item: function (data) {
        var html = $('[news-item]:eq(0)').clone();

        html.find('[news-date]').html(news.date(data.created_at));
        html.find('[news-short-text]').html(data.name);
        html.find('[news-img]').attr('src', image.url(data.images[0], 300));
        html.find('[news-url]').attr('href', '/news/'+ data.id);

        return html;
    },

    load: function (page, callback) {
        if (news.data) {
            scroll.to($('a[name="news"]'));
        }

        news.page = page;

        $('[news-currentpage]').html(news.page);

        ajax({
            url: '/news' + (page ? '?page=' + page : ''),
            preloader: $('[news-list]'),
        }, function (json) {
            news.last_page = json.last_page;
            news.data = json.data;

            news.print();

            if (callback) callback();
        });
    },

    print: function () {
        $('[news-lastpage]').html(news.last_page);
        $('[news-list]').html('');
        if (news.data.length) {
            $.each(news.data, function (i, item) {
                $('[news-list]').append(news.item(item));
            });
        } else {
            $('[news-currentpage]').html(0);
            $('[news-lastpage]').html(0);
        }
    }

};

$(news.init);